import hasPermi from "./hasPermi";
export default function directives (app) {
  hasPermi(app)
}